import * as React from "react";
import { Flex, Text } from "@chakra-ui/react";
import { Wrapper, Search, Tags } from "components";
import { useQueryParams } from "../../duck";
import { Filters, Protocol, Skeleton, Title } from "./components";
import {
  AnestheticProtocol,
  SelectionContext,
  useAnestheticProtocols
} from "./duck";

const List: React.FC = () => {
  const [params] = useQueryParams();
  const doctors = params.filter?.doctors?.map((docId: string) => +docId);
  const [selectedProtocols, setSelectedProtocols] = React.useState<
    AnestheticProtocol[]
  >([]);
  const { anestheticProtocols, loading } = useAnestheticProtocols();

  return (
    <SelectionContext.Provider
      value={{
        selected: selectedProtocols,
        setSelected: protocols => setSelectedProtocols(protocols)
      }}
    >
      <Title />

      <Wrapper mt={6}>
        <Flex direction="column" rowGap={6}>
          <Flex columnGap={4}>
            <Search />
            <Filters />
          </Flex>
          {!!doctors && <Tags withDoctors />}
        </Flex>

        <Flex direction="column" mt={4}>
          {anestheticProtocols.map((protocol, i) => (
            <Protocol
              key={protocol._id}
              data={protocol}
              last={i === anestheticProtocols.length - 1}
            />
          ))}

          {loading ? (
            <Skeleton />
          ) : (
            !anestheticProtocols.length && (
              <Flex justifyContent="center" w="100%">
                <Text my={6} fontWeight={600} fontSize="16px" align="center">
                  No results found
                </Text>
              </Flex>
            )
          )}
        </Flex>
      </Wrapper>
    </SelectionContext.Provider>
  );
};

export default List;
